export const siteConfig = {
  name: '爱风月',
  tagline: '风雅情趣生活美学',
  description: '爱风月，是一种对生活诗意与浪漫的深情追求。汇聚风月文化内涵、生活方式与美学体验。',
  url: 'https://aifengyue.com',
};

export const categories = [
  { slug: 'fengya-shenghuo', name: '风雅生活', icon: 'ri-moon-line', description: '探寻古典与现代交融的风雅生活方式，在日常中觅得诗意栖居。' },
  { slug: 'yuexia-fengliu', name: '月下风流', icon: 'ri-star-line', description: '月华如水，风流自赏。月下独酌、对月吟诗的浪漫情怀。' },
  { slug: 'qingqu-yazhi', name: '情趣雅致', icon: 'ri-leaf-line', description: '从茶道、香道到花艺，品味生活中的精致情趣与雅致格调。' },
  { slug: 'gufeng-meixue', name: '古风美学', icon: 'ri-brush-line', description: '追溯传统美学根源，感受古风之美在当代生活中的延续与新生。' },
  { slug: 'shiyi-langman', name: '诗意浪漫', icon: 'ri-heart-line', description: '以诗为媒，以情为引，在平凡日子里创造不平凡的浪漫瞬间。' },
  { slug: 'wenhua-shenyun', name: '文化神韵', icon: 'ri-book-open-line', description: '深入风月文化底蕴，解读千年文脉中的审美智慧与精神追求。' },
];

export const homepageArticles = [
  {
    id: 'article-1',
    title: '月下独酌：古人如何在月光中寻得诗意',
    excerpt: '月色如水，洒落庭院。千百年来，无数文人墨客在月下独酌，将对人生的感悟化作千古绝唱。让我们一同走进那些被月光浸润的夜晚，感受古人的诗意情怀。',
    category: '月下风流',
    categorySlug: 'yuexia-fengliu',
    date: '2026-08-05',
    readTime: '8分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20scholar%20drinking%20alone%20under%20bright%20full%20moon%20in%20classical%20garden%2C%20bamboo%20shadows%20on%20white%20wall%2C%20warm%20lantern%20light%2C%20Song%20dynasty%20aesthetic%2C%20ink%20wash%20painting%20style%2C%20soft%20moonlight%20filtering%20through%20clouds%2C%20poetic%20atmosphere%2C%20elegant%20composition&width=800&height=500&seq=article-1&orientation=landscape',
  },
  {
    id: 'article-2',
    title: '茶香袅袅：一壶清茶里的风雅人生',
    excerpt: '茶，是风雅生活的最佳伴侣。从选茶、煮水到品饮，每一个环节都蕴含着东方美学的精髓。在茶香氤氲中，我们找到了与自我对话的最佳方式。',
    category: '情趣雅致',
    categorySlug: 'qingqu-yazhi',
    date: '2026-08-02',
    readTime: '6分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20tea%20ceremony%20set%20on%20dark%20wooden%20table%2C%20white%20porcelain%20teapot%20with%20steam%20rising%2C%20bamboo%20tea%20scoop%2C%20warm%20candlelight%2C%20serene%20zen%20atmosphere%2C%20minimalist%20oriental%20interior%2C%20soft%20natural%20light%20from%20paper%20window%2C%20elegant%20still%20life%20photography&width=800&height=500&seq=article-2&orientation=landscape',
  },
  {
    id: 'article-3',
    title: '花间一壶酒：诗词中的风月意象探微',
    excerpt: '风与月，是中国古典诗词中最常见的意象组合。它们不仅代表着自然之美，更承载着文人对自由、爱情与理想的无限向往。本文带你细品诗词中的风月密码。',
    category: '文化神韵',
    categorySlug: 'wenhua-shenyun',
    date: '2026-07-28',
    readTime: '10分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Classical%20Chinese%20poetry%20scroll%20with%20brush%20calligraphy%20on%20aged%20rice%20paper%2C%20plum%20blossoms%20branch%2C%20ink%20stone%20and%20brush%2C%20warm%20amber%20lighting%2C%20antique%20wooden%20desk%2C%20Song%20dynasty%20scholarly%20atmosphere%2C%20elegant%20cultural%20still%20life%2C%20soft%20golden%20hour%20glow&width=800&height=500&seq=article-3&orientation=landscape',
  },
  {
    id: 'article-4',
    title: '庭院深深：打造属于你的风雅空间',
    excerpt: '一方庭院，便是整个天地。无论居所大小，都可以通过巧妙布置，营造出充满风雅情趣的生活空间。从家具选择到绿植搭配，让家成为诗意栖居之所。',
    category: '风雅生活',
    categorySlug: 'fengya-shenghuo',
    date: '2026-07-25',
    readTime: '7分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Serene%20Chinese%20courtyard%20garden%20with%20wooden%20pavilion%2C%20koi%20pond%2C%20moss-covered%20rocks%2C%20bonsai%20trees%2C%20traditional%20latticed%20windows%2C%20warm%20afternoon%20sunlight%2C%20elegant%20landscape%20design%2C%20peaceful%20zen%20atmosphere%2C%20high-end%20interior%20design%20photography&width=800&height=500&seq=article-4&orientation=landscape',
  },
  {
    id: 'article-5',
    title: '琴瑟和鸣：古乐中的浪漫与深情',
    excerpt: '古琴一曲，胜过千言万语。在中国传统音乐中，琴瑟之音不仅代表着最高雅的审美追求，更是表达深情厚意的最佳载体。聆听古乐，感受穿越千年的浪漫。',
    category: '古风美学',
    categorySlug: 'gufeng-meixue',
    date: '2026-07-20',
    readTime: '9分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20guqin%20zither%20on%20wooden%20stand%2C%20incense%20smoke%20curling%2C%20silk%20curtains%20flowing%20in%20breeze%2C%20warm%20candlelight%2C%20traditional%20Chinese%20interior%20with%20calligraphy%20scrolls%2C%20serene%20meditative%20atmosphere%2C%20soft%20focus%2C%20artistic%20composition&width=800&height=500&seq=article-5&orientation=landscape',
  },
  {
    id: 'article-6',
    title: '二十四节气中的风月之美',
    excerpt: '春有百花秋有月，夏有凉风冬有雪。二十四节气不仅是农耕文明的智慧结晶，更蕴含着中国人对自然之美的细腻感知。跟随节气流转，感受时光中的风月之美。',
    category: '诗意浪漫',
    categorySlug: 'shiyi-langman',
    date: '2026-07-15',
    readTime: '12分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Four%20seasons%20of%20Chinese%20landscape%20in%20single%20composition%2C%20cherry%20blossoms%20spring%2C%20lotus%20pond%20summer%2C%20red%20maple%20autumn%2C%20snow%20covered%20pavilion%20winter%2C%20traditional%20Chinese%20painting%20style%2C%20soft%20dreamy%20atmosphere%2C%20poetic%20landscape%2C%20warm%20golden%20and%20cool%20silver%20tones&width=800&height=500&seq=article-6&orientation=landscape',
  },
];

export const philosophyItems = [
  {
    icon: 'ri-moon-clear-line',
    title: '风月之道',
    description: '风无形而有声，月无言而有光。风月之道，在于顺应自然，以一颗澄明之心感受天地万物的灵动与美好。',
  },
  {
    icon: 'ri-heart-pulse-line',
    title: '情趣之韵',
    description: '生活中的情趣不在远方，而在日常的细微之处。一杯茶、一炷香、一卷书，皆可成为风雅之源。',
  },
  {
    icon: 'ri-paint-brush-line',
    title: '美学之境',
    description: '将古典美学融入现代生活，让每一刻都充满诗意。在喧嚣都市中，为自己营造一方风月净土。',
  },
];